var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 199.3 41.1",
    enableBackground: "new 0 0 199.3 41.1",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5,34.3c-1.8,0.4-3.7,0.2-5.3-0.7c-0.5-0.3-1-0.6-1.5-0.9c-0.5-0.4-0.9-0.7-1.3-1.2c-0.4-0.5-0.8-1-1.1-1.6l22.8-5.1 c0-1.2-0.1-2.4-0.4-3.6c-0.9-4.1-3.4-7.7-6.9-9.9c-7.1-4.6-16.6-2.6-21.3,4.5c-0.1,0.2-0.2,0.3-0.3,0.5c-2.3,3.7-3,8.1-2,12.3 c0.2,1,0.5,2,1,3c0.4,1.1,1,2.1,1.7,3c1.2,1.6,2.7,2.9,4.4,3.9c3.5,2.3,7.9,3.1,12,2.1c3.2-0.7,6-2.4,8.1-4.9 c1.1-1.2,2-2.7,2.7-4.2h-8C46.9,33,45.3,34,43.5,34.3z M34.7,18.6c1.2-1.6,3-2.7,4.9-3.1c1.9-0.5,3.9-0.2,5.7,0.7 c1.8,1,3.3,2.5,4.1,4.4l-16.5,3.7C32.8,22.3,33.4,20.3,34.7,18.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5,34.3c-1.8,0.4-3.7,0.2-5.3-0.6c-0.5-0.3-1-0.6-1.5-0.9c-0.5-0.3-0.9-0.7-1.3-1.2c-0.4-0.5-0.8-1-1.1-1.6l22.8-5.1 c0-1.2-0.1-2.4-0.4-3.6c-0.9-4.1-3.4-7.7-6.9-9.9c-7.1-4.6-16.6-2.6-21.3,4.5c-0.1,0.2-0.2,0.3-0.3,0.5c-2.3,3.7-3,8.1-2,12.3 c0.2,1,0.5,2,0.9,3c0.4,1.1,1,2.1,1.7,3c1.2,1.6,2.7,2.9,4.4,3.9c3.5,2.3,7.9,3.1,12,2.1c3.1-0.7,6-2.4,8.1-4.9 c1.1-1.2,2-2.7,2.7-4.2h-8C81.9,33,80.3,34,78.5,34.3z M69.7,18.6c1.2-1.6,3-2.7,4.9-3.1c1.9-0.5,3.9-0.2,5.7,0.7 c1.8,1,3.3,2.5,4.1,4.4l-16.6,3.7C67.8,22.3,68.4,20.3,69.7,18.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.1,34.3c-1.8,0.4-3.7,0.2-5.3-0.7c-0.5-0.3-1-0.6-1.5-0.9c-0.5-0.4-0.9-0.8-1.3-1.2c-0.4-0.5-0.8-1-1.1-1.6l22.8-5.2 c0-1.2-0.1-2.4-0.4-3.6c-0.9-4.1-3.4-7.7-6.9-9.9c-3.4-2.3-7.7-3.1-11.7-2.1c-4.1,0.9-7.7,3.5-9.9,7.1c-2.3,3.7-3,8.1-2,12.3 c0.2,1,0.5,2,0.9,3c0.4,1.1,1,2.1,1.7,3c1.2,1.6,2.6,3,4.3,4c3.5,2.3,7.9,3.1,12,2.1c3.2-0.7,6-2.4,8.1-4.9c1.1-1.3,2-2.7,2.7-4.3 h-8C144.5,32.9,142.9,34,141.1,34.3z M132.2,18.6c1.2-1.6,3-2.7,4.9-3.1c1.9-0.5,3.9-0.2,5.7,0.7c1.8,1,3.2,2.5,4.1,4.4l-16.5,3.7 C130.3,22.3,131,20.3,132.2,18.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M176.1,34.3c-1.8,0.4-3.7,0.2-5.3-0.7c-0.5-0.3-1-0.6-1.5-0.9c-0.5-0.4-0.9-0.8-1.3-1.2c-0.4-0.5-0.8-1-1.1-1.6l22.7-5.2 c0-1.2-0.1-2.4-0.4-3.6c-0.9-4.1-3.4-7.7-6.9-9.9c-7.1-4.6-16.7-2.6-21.3,4.5c-0.1,0.2-0.2,0.3-0.3,0.5c-2.3,3.7-3,8.1-2,12.3 c0.2,1,0.6,2,1,3c0.4,1.1,1,2.1,1.7,3c3.8,5.1,10.2,7.5,16.4,6.2c3.2-0.7,6-2.4,8.1-4.9c1.1-1.3,2-2.7,2.7-4.3h-8 C179.5,33,177.9,34,176.1,34.3z M167.3,18.6c1.2-1.6,3-2.7,4.9-3.1c1.9-0.5,3.9-0.2,5.7,0.7c1.8,1,3.2,2.5,4.1,4.4l-16.6,3.7 C165.4,22.3,166,20.3,167.3,18.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.39,
    y1: 73.0999,
    x2: 110.39,
    y2: 138.5099,
    gradientTransform: "matrix(1 0 0 -1 0 125.3199)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2795BA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4ADEDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    style: {
      stopColor: "#60A5FC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7263E6"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M102.7,15.3h-9l7.6,17.3l0,0l3.5,8.6l1.8-9.6L102.7,15.3z M127.1,0l-13.3,32.5l0,0l-3.5,8.6h-5.6 l2.8-8.6l0,0L118.3,0L127.1,0z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5,0v29.3c0,0.7-0.1,1.5-0.2,2.2c-0.3,1.6-1.7,2.8-3.4,2.6c-1.6,0.1-3-1-3.4-2.6H0c0.2,1.7,0.7,3.3,1.6,4.8 c2.1,3.1,5.7,4.9,9.4,4.8c3,0.1,5.9-1.1,8-3.3c1.5-1.8,2.5-3.9,2.8-6.2c0.1-0.9,0.2-1.8,0.2-2.7V0H14.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M195,36.6c0.4-0.1,0.8-0.3,1-0.6c0.2-0.3,0.3-0.6,0.3-1c0-0.4-0.1-0.7-0.4-1c-0.4-0.4-0.9-0.6-1.4-0.5H193v5h0.9v-2 l1.3,1.9h1.1L195,36.6z M193.9,35.9v-1.5h0.6c0.2,0,0.4,0.1,0.6,0.2c0.2,0.1,0.3,0.4,0.2,0.6c0,0.2-0.1,0.4-0.2,0.5 c-0.2,0.1-0.4,0.2-0.6,0.2H193.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M194.5,31.5c-2.6,0-4.8,2.2-4.8,4.8c0,2.6,2.2,4.8,4.8,4.8c2.6,0,4.8-2.2,4.8-4.8C199.3,33.7,197.1,31.5,194.5,31.5 C194.5,31.5,194.5,31.5,194.5,31.5z M194.5,40.7c-2.4,0-4.3-2-4.3-4.4c0-2.4,2-4.3,4.4-4.3c2.4,0,4.3,2,4.3,4.3 C198.8,38.7,196.9,40.6,194.5,40.7L194.5,40.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3219b21ff9aa99c94ae1e73c3c12500b.svg";
export { ForwardRef as ReactComponent };